import { useEffect, useState } from 'react';

import { transcriptionAPI } from '../services/api';
import { DEFAULT_AUDIO_MAX_MB, resolveAudioMaxMb } from '../config/uploadLimits';

/**
 * Server-provided audio upload limit in MB (CHAT-27). Starts at the shared
 * fallback and switches to `max_size_mb` from /api/transcriptions/formats once
 * it loads (the API client caches that response).
 */
export function useAudioUploadLimit(): number {
  const [maxMb, setMaxMb] = useState<number>(DEFAULT_AUDIO_MAX_MB);

  useEffect(() => {
    let cancelled = false;
    transcriptionAPI
      .getFormats()
      .then((limits) => {
        if (!cancelled) setMaxMb(resolveAudioMaxMb(limits));
      })
      .catch((error) => {
        console.warn('Failed to load audio upload limits:', error);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return maxMb;
}
